import gsap from "gsap";

function mainMenu() {
	const hamburger   = document.querySelector( '.hamburger-menu' )
    const mainMenu    = document.querySelector( '#main-menu' )
	const firstLevel  = document.querySelector( '.menu-wrapper' )
	const secondLevel = document.querySelectorAll( '.sub-menu-wrap[data-menu-level="2"]' )
	const thirdLevel  = document.querySelectorAll( '.sub-menu-wrap[data-menu-level="3"]' )
	const allSubMenus = document.querySelectorAll('.sub-menu-wrap')
	const menuOverlay = document.querySelector('.menu-overlay')

	const hasChildren = document.querySelectorAll( '.menu-item-has-children > a' )

	const menuWidth = firstLevel.offsetWidth;


	/**
	 * Function to close the menu (full)
	 */
	function showOverlay() {
		gsap.to( menuOverlay, { autoAlpha: 1, duration: 0.3 } )
		menuOverlay.classList.remove( 'pointer-events-none' )
	}
	function closeMenu(){
		document.querySelector('body').classList.remove('menu-open')
		document.body.classList.remove('scroll-lock')
	
		gsap.to( firstLevel, { right: - menuWidth - 20, duration: 0.3 } )
		gsap.to( allSubMenus, { right: - menuWidth - 20, duration: 0.3 } )
		gsap.to( menuOverlay, { autoAlpha: 0, duration: 0.3 } )
	
		menuOverlay.classList.add( 'pointer-events-none' )
	}

	function openFirstLevel(){
		gsap.to( firstLevel, { right: 0, duration: 0.5 } )

		showOverlay()
	}

	function openSecondLevel(menuToOpen){
		showOverlay()

		const allOtherMenus = Array.from(allSubMenus).filter(menu => menu!== menuToOpen)

		gsap.to( firstLevel, { right: menuWidth, duration: 0.3 } )
		gsap.to( menuToOpen, { right: 0, duration: 0.3 } )
		gsap.to( allOtherMenus, { right: - menuWidth - 20, duration: 0.5 } )
	}

	function closeSecondLevel(menuToClose){
		const allOtherMenus = Array.from(allSubMenus).filter(menu => menu!== menuToClose)

		gsap.to( firstLevel, { right: 0, duration: 0.3 } )
		gsap.to( menuToClose, { right: - menuWidth - 20, duration: 0.3 } )
		gsap.to( allOtherMenus, { right: - menuWidth - 20, duration: 0.5 } )
	}


	function openThirdLevel(menuToOpen){
		showOverlay()

		const sedondLevel   = menuToOpen.parentNode.parentNode.parentNode
		const allOtherMenus = Array.from(thirdLevel).filter(menu => menu!== menuToOpen)

		if ( window.innerWidth >= 992 ){
			gsap.to( firstLevel, { right: menuWidth * 2, duration: 0.3 } )
		} else {
			gsap.to( firstLevel, { right: 0, duration: 0 } )  // IMPORTANT: It's a bit hacky, but if instead of 0 we set it wo menuWidth * 2, as it should, it breaks on iPhone.
		}
		gsap.to( sedondLevel, { right: menuWidth, duration: 0.3 } )
		gsap.to( menuToOpen, { right: 0, duration: 0.3 } )
		gsap.to( allOtherMenus, { right: - menuWidth - 20, duration: 0.5 } )
	}

	function closeThirdLevel(menuToClose){
		const sedondLevel   = menuToClose.parentNode.parentNode.parentNode
		const allOtherMenus = Array.from(thirdLevel).filter(menu => menu!== menuToClose)
		gsap.to( firstLevel, { right: menuWidth, duration: 0.3 } )
		gsap.to( sedondLevel, { right: 0, duration: 0.3 } )
		gsap.to( menuToClose, { right: - menuWidth - 20, duration: 0.3 } )
		gsap.to( allOtherMenus, { right: - menuWidth - 20, duration: 0.5 } )
	}



	// Open and close menu - Level 1 (first load)
	hamburger.addEventListener( 'click', function(){
		document.querySelector('body').classList.toggle('menu-open') // Menu is active
		document.body.classList.toggle('scroll-lock')                // Body scroll lock

		if( document.body.classList.contains('menu-open') ) {
			// Open
			const currentMenuItem = document.querySelector('.current-menu-item')

			// If the current item on the menu is present, we open the menu to show it.
			if ( currentMenuItem ) {
				const menuLevel = currentMenuItem.parentNode.parentNode.dataset.menuLevel
	
				if ( menuLevel == 2 ){
					openSecondLevel(currentMenuItem.parentNode.parentNode)
				} else if ( menuLevel == 3 ) {
					openThirdLevel(currentMenuItem.parentNode.parentNode)
				} else {
					openFirstLevel()
				}
			} else {
				openFirstLevel()
			}

		} else {
			// Close
			closeMenu()
		}
	} )


	// Open and close menu - menu-item-has-children
	hasChildren.forEach(menuItem => {
		menuItem.addEventListener( 'click', function(e){
			e.preventDefault()

			const menuToOpen    = menuItem.parentNode.querySelector('.sub-menu-wrap')
			const thisMenuLevel = menuToOpen.dataset.menuLevel

			if ( thisMenuLevel == 2 ){
				openSecondLevel(menuToOpen)
				
			} else if ( thisMenuLevel == 3 ){
				openThirdLevel(menuToOpen)
			}
		})
	});


	// Close menu when clicking the back button (mobile)
	const backButton = document.querySelectorAll('.back-menu')

	if ( backButton.length > 0 ){
		backButton.forEach(button => {
			button.addEventListener( 'click', function(e){
				e.preventDefault()

				const menuToClose   = button.parentNode.parentNode
				const thisMenuLevel = menuToClose.dataset.menuLevel

				if ( thisMenuLevel == 2 ){
					closeSecondLevel(menuToClose)
					
				} else if ( thisMenuLevel == 3 ){
					closeThirdLevel(menuToClose)
				}
			})
		})
	}


	// Close all when overlay clicked
	menuOverlay.addEventListener( 'click', function(){
		closeMenu()
	})
}

export default mainMenu;
